// availity-reactstrap-validation
import UploadForm from "components/shared-components/UploadForm";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import MetaTags from "react-meta-tags";
//redux
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Label,
  Media,
  Row,
  Spinner,
} from "reactstrap";
import { resetUploadAvatar, updateProfile, uploadAvatar } from "store/actions";
import {
  UPDATE_PROFILE_FAIL,
  UPDATE_PROFILE_SUCCESS,
  UPLOAD_AVATAR_FAIL,
} from "store/auth/profile/actionTypes";
import * as yup from "yup";
import avatar from "../../assets/images/users/avatar-default.png";
//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";

const UserProfile = props => {
  const { t, i18n } = useTranslation("common");
  const dispatch = useDispatch();
  const { addToast } = useToasts();

  const Profile = useSelector(state => state.Profile);
  const { userInfo, avatarImg, avatar_id, avatar_id_upload, loading, type } =
    Profile;

  const [imgAvatar, setAvatar] = useState(null);
  const [nameChange, setNameChange] = useState(null);

  const schema = yup.object().shape({
    display_name: yup
      .string()
      .required(t("validate.required", { title: t("profile.displayName") })),
    // avatar: yup.string(),
    //   .required(t("validate.select", { title: t("profile.avatar") })),
  });

  const {
    handleSubmit,
    formState: { errors, touchedFields },
    setValue,
    register,
  } = useForm({
    // resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
  });

  useEffect(() => {
    return () => {
      dispatch(resetUploadAvatar());
    };
  }, []);

  useEffect(() => {
    switch (type) {
      case UPDATE_PROFILE_SUCCESS:
        addToast(t("profile.updateProfileSuccess"), {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(resetUploadAvatar());
        break;
      case UPDATE_PROFILE_FAIL:
        addToast(t("profile.updateProfileFail"), {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetUploadAvatar());
        break;
      case UPLOAD_AVATAR_FAIL:
        addToast(t("profile.choseAvatarFail"), {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetUploadAvatar());
        break;
      default:
        break;
    }
  }, [type]);

  useEffect(() => {
    if (userInfo) {
      setValue("display_name", userInfo?.display_name, {
        shouldValidate: true,
      });
    }
  }, [userInfo]);

  const handleFiles = files => {
    if (files.length > 0) {
      setAvatar(files[0]);
      const data = new FormData();
      data.append("file", files[0]);
      dispatch(uploadAvatar(data));
    }
  };

  const submitForm = submitData => {
    const { display_name } = submitData;
    const avatarId = avatar_id_upload ? avatar_id_upload : avatar_id;

    dispatch(updateProfile(display_name, avatarId));
  };

  const changeDisplayName = event => {
    setNameChange(event.target.value);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{t("profile.info")}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title="Profile" breadcrumbItem={t("profile.info")} />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  {loading ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Spinner color="primary" />
                    </div>
                  ) : (
                    <Media>
                      <div className="ms-3">
                        <img
                          src={
                            imgAvatar
                              ? imgAvatar.preview
                              : avatarImg
                              ? avatarImg
                              : avatar
                          }
                          alt="Avatar"
                          className="avatar-lg rounded-circle img-thumbnail"
                        />
                      </div>
                      <Media body className="align-self-center">
                        <div className="text-muted">
                          <h5>
                            {nameChange ? nameChange : userInfo?.display_name}
                          </h5>
                          <p className="mb-1">{userInfo?.username}</p>
                          <p className="mb-0">
                            {t("profile.checker_date")}
                            {userInfo?.checker_date &&
                              Intl.DateTimeFormat("en-GB", {
                                year: "numeric",
                                month: "2-digit",
                                day: "2-digit",
                                hour: "2-digit",
                                minute: "2-digit",
                              }).format(userInfo?.checker_date * 1000)}
                          </p>
                        </div>
                      </Media>
                    </Media>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>

          <h4 className="card-title mb-4">{t("profile.updateInfo")}</h4>
          <Card>
            <CardBody>
              <FormGroup className="mb-3">
                {/* <Label htmlFor="display_name">
                  {t("profile.displayName")}{" "}
                  <span className="text-danger">*</span>
                </Label>
                <input
                  type="text"
                  className={`form-control ${formValidate(
                    errors,
                    touchedFields,
                    "display_name"
                  )}`}
                  placeholder={t("placeholder.enter", {
                    title: t("profile.displayName"),
                  })}
                  {...register("display_name")}
                  onChange={changeDisplayName}
                />
                {errors.display_name && (
                  <MessageFormValidate error={errors.display_name.message} />
                )} */}
              </FormGroup>
              <FormGroup className="mb-3">
                <Label htmlFor="avatar">{t("profile.avatar")}</Label>
                <UploadForm
                  multiple={false}
                  handleFiles={files => handleFiles(files)}
                  accept=".png, .jpg, .jpeg"
                ></UploadForm>
                {/* {errors.avatar && (
                  <MessageFormValidate error={errors.avatar.message} />
                )}
                <input type="hidden" {...register("avatar")} /> */}
              </FormGroup>
              <div className="mt-4">
                <Button
                  type="button"
                  color="primary"
                  disabled={loading}
                  className="mb-2 me-2 btn-label"
                  onClick={handleSubmit(submitForm)}
                >
                  <i className="bx bx-save label-icon" />
                  {t("profile.btnUpdate")}
                </Button>
              </div>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UserProfile;
